import React from 'react';
import MarkerGauge from '@splunk/dashboard-visualizations/MarkerGauge';

export default () => (
    <MarkerGauge
        options={{ showLabels: false }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [{ name: 'count' }],
                    columns: [['78']],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
